"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanPhoneString = exports.isValidPhone = exports.guessIsMobile = exports.getAllPredialsByCountryName = exports.getCountryByPreDial = exports.mapSubRegionID2Region = exports.getRegisteredCountryList = exports.getRegisteredCountries = exports.isCountryRegistered = exports.getSupportedCurrencies = exports.getCountryCode2CurrencyMap = exports.REGISTERED_COUNTRYCODES = void 0;
var countryModel_1 = require("./countryModel");
exports.REGISTERED_COUNTRYCODES = ['DE', 'AT', 'CH', 'LI', 'LU', 'ES', 'BE', 'NL', 'FR', 'IT', 'SE', 'GB', 'PL'];
var COUNTRY_TO_CURRENCY_MAP = {
    DE: 'EUR',
    AT: 'EUR',
    CH: 'CHF',
    LI: 'EUR',
    LU: 'EUR',
    ES: 'EUR',
    BE: 'EUR',
    NL: 'EUR',
    FR: 'EUR',
    IT: 'EUR',
    SE: 'SEK',
    GB: 'GBP',
    PL: 'PLN'
};
var CURRENCY_LIST = ['EUR', 'CHF', 'GBP', 'SEK', 'PLN'];
var getCountryCode2CurrencyMap = function (countryCode) { return COUNTRY_TO_CURRENCY_MAP[countryCode]; };
exports.getCountryCode2CurrencyMap = getCountryCode2CurrencyMap;
var getSupportedCurrencies = function () { return CURRENCY_LIST; };
exports.getSupportedCurrencies = getSupportedCurrencies;
function isCountryRegistered(alpha2) {
    return exports.REGISTERED_COUNTRYCODES.includes(alpha2.toUpperCase());
}
exports.isCountryRegistered = isCountryRegistered;
function getRegisteredCountries() {
    var result = {};
    exports.REGISTERED_COUNTRYCODES.forEach(function (t) {
        result[t] = countryModel_1.ALL_COUNTRIES[t];
    });
    return result;
}
exports.getRegisteredCountries = getRegisteredCountries;
function getRegisteredCountryList() {
    return exports.REGISTERED_COUNTRYCODES.map(function (t) { return countryModel_1.ALL_COUNTRIES[t]; });
}
exports.getRegisteredCountryList = getRegisteredCountryList;
function mapSubRegionID2Region(SubregionId) {
    var regionId = Object.keys(countryModel_1.MAP_REGIONID_2_SUBREGION).find(function (t) { return countryModel_1.MAP_REGIONID_2_SUBREGION[+t] === SubregionId; });
    return regionId && +regionId || undefined;
}
exports.mapSubRegionID2Region = mapSubRegionID2Region;
function getCountryByPreDial(preDial) {
    return Object.values(countryModel_1.ALL_COUNTRIES).find(function (c) { return c.preDial === preDial; });
}
exports.getCountryByPreDial = getCountryByPreDial;
function getAllPredialsByCountryName() {
    return Object.values(countryModel_1.ALL_COUNTRIES).map(function (country) { return ({ country_code: country.country_code, preDial: country.preDial, name: country.name }); });
}
exports.getAllPredialsByCountryName = getAllPredialsByCountryName;
function preparePredialForRegexp(preDial) {
    if (!preDial) {
        return '';
    }
    return preDial.startsWith("+") ? "\\" + preDial : preDial;
}
function stripPredialForRegexp(preDial) {
    return preDial.startsWith("+") ? preDial.substring(1) : preDial;
}
function getRegExMobileForCountry(country) {
    var regexWithPredial = country.mobilePreDials.map(function (p) { return new RegExp(preparePredialForRegexp(country.preDial) + p); });
    var regexWithPredialInternational = country.mobilePreDials.map(function (p) { return new RegExp(country.internationalPreDial + stripPredialForRegexp(country.preDial) + p); });
    var regexWithNationalPredial = country.mobilePreDials.map(function (p) { return new RegExp('^' + preparePredialForRegexp(country.nationalPreDial) + p); });
    return regexWithPredial.concat(regexWithNationalPredial).concat(regexWithPredialInternational);
}
function guessIsMobile(phone, homeCountryCode, checkRegisteredCountries) {
    if (checkRegisteredCountries === void 0) { checkRegisteredCountries = false; }
    var homeCountry = countryModel_1.ALL_COUNTRIES[homeCountryCode.toUpperCase()];
    var homeCountryRegexList = getRegExMobileForCountry(homeCountry);
    var cleanedPhoneString = phone.replace(/[^\d+]/g, '');
    var found = homeCountryRegexList.find(function (r) { return r.test(cleanedPhoneString); });
    if (!found && checkRegisteredCountries) {
        var relevantCountries = Object.values(getRegisteredCountries()).filter(function (c) { return c.country_code !== homeCountryCode.toUpperCase(); });
        var relevantCountriesRegexList = relevantCountries.reduce(function (result, country) {
            return result.concat(getRegExMobileForCountry(country));
        }, []);
        found = relevantCountriesRegexList.find(function (r) { return r.test(cleanedPhoneString); });
    }
    return Boolean(found);
}
exports.guessIsMobile = guessIsMobile;
function isValidPhone(phoneString, countryCode) {
    var cleanPhoneString = phoneString.replace(/[^+\d]/g, '');
    if (((cleanPhoneString === null || cleanPhoneString === void 0 ? void 0 : cleanPhoneString.length) || 0) < 8) {
        return false;
    }
    var homeCountry = countryModel_1.ALL_COUNTRIES[countryCode.toUpperCase()];
    if (!homeCountry) {
        return true;
    }
    return cleanPhoneString.startsWith('+')
        || homeCountry.nationalPreDial == null
        || cleanPhoneString.startsWith(homeCountry.nationalPreDial);
}
exports.isValidPhone = isValidPhone;
function cleanPhoneString(phoneString, countryCode) {
    if (!isValidPhone(phoneString, countryCode)) {
        return null;
    }
    var cleanedPhoneString = phoneString.replace(/[^\d+]/g, '');
    if (cleanedPhoneString.startsWith('+')) {
        return cleanedPhoneString;
    }
    var homeCountry = countryModel_1.ALL_COUNTRIES[countryCode.toUpperCase()];
    if (!homeCountry) {
        return null;
    }
    if (cleanedPhoneString.startsWith(homeCountry.internationalPreDial)) {
        return cleanedPhoneString.replace(homeCountry.internationalPreDial, '+');
    }
    if (homeCountry.nationalPreDial != null && cleanedPhoneString.startsWith(homeCountry.nationalPreDial)) {
        return cleanedPhoneString.replace(homeCountry.nationalPreDial, homeCountry.preDial);
    }
    return homeCountry.nationalPreDial == null ? homeCountry.preDial + cleanedPhoneString : null;
}
exports.cleanPhoneString = cleanPhoneString;
